// This file is auto-generated by @hey-api/openapi-ts

import type { CancelablePromise } from './core/CancelablePromise';
import { OpenAPI } from './core/OpenAPI';
import { request as __request } from './core/request';
import type { $OpenApiTs } from './models';

export class AuthenticationService {
  /**
   * @returns User
   * @throws ApiError
   */
  public static login(
    data: $OpenApiTs['/api/v1/authentication']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/v1/authentication']['post']['res'][201]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/authentication',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns User
   * @throws ApiError
   */
  public static getProfile(): CancelablePromise<$OpenApiTs['/api/v1/authentication']['get']['res'][200]> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/authentication',
    });
  }

  /**
   * @returns void
   * @throws ApiError
   */
  public static logout(): CancelablePromise<$OpenApiTs['/api/v1/authentication']['delete']['res'][204]> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/v1/authentication',
    });
  }

  /**
   * @returns any
   * @throws ApiError
   */
  public static forgotPassword(
    data: $OpenApiTs['/api/v1/authentication/forgot-password']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/v1/authentication/forgot-password']['post']['res'][201]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/authentication/forgot-password',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns any
   * @throws ApiError
   */
  public static resetPassword(
    data: $OpenApiTs['/api/v1/authentication/reset-password']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/v1/authentication/reset-password']['post']['res'][201]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/authentication/reset-password',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
}

export class HealthService {
  /**
   * @returns any The Health Check is successful
   * @throws ApiError
   */
  public static check(): CancelablePromise<$OpenApiTs['/api/v1/health']['get']['res'][200]> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/health',
      errors: {
        503: `The Health Check is not successful`,
      },
    });
  }
}

export class CaslService {
  /**
   * @returns CaslRulesDto
   * @throws ApiError
   */
  public static getRules(): CancelablePromise<$OpenApiTs['/api/v1/casl']['get']['res'][200]> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/casl',
    });
  }
}

export class UsersService {
  /**
   * @returns User
   * @throws ApiError
   */
  public static create(
    data: $OpenApiTs['/api/v1/users']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/v1/users']['post']['res'][201]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/users',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns User
   * @throws ApiError
   */
  public static findAll(
    data: $OpenApiTs['/api/v1/users']['get']['req'] = {},
  ): CancelablePromise<$OpenApiTs['/api/v1/users']['get']['res'][200]> {
    const { search, status, role } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/users',
      query: {
        search,
        status,
        role,
      },
    });
  }

  /**
   * @returns User
   * @throws ApiError
   */
  public static findOne(
    data: $OpenApiTs['/api/v1/users/{id}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/v1/users/{id}']['get']['res'][200]> {
    const { id } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/users/{id}',
      path: {
        id,
      },
    });
  }

  /**
   * @returns User
   * @throws ApiError
   */
  public static update(
    data: $OpenApiTs['/api/v1/users/{id}']['patch']['req'],
  ): CancelablePromise<$OpenApiTs['/api/v1/users/{id}']['patch']['res'][200]> {
    const { id, requestBody } = data;
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/v1/users/{id}',
      path: {
        id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns User
   * @throws ApiError
   */
  public static remove(
    data: $OpenApiTs['/api/v1/users/{id}']['delete']['req'],
  ): CancelablePromise<$OpenApiTs['/api/v1/users/{id}']['delete']['res'][200]> {
    const { id } = data;
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/v1/users/{id}',
      path: {
        id,
      },
    });
  }
}

export class InvitationsService {
  /**
   * @returns User
   * @throws ApiError
   */
  public static accept(
    data: $OpenApiTs['/api/v1/invitations/{userId}']['patch']['req'],
  ): CancelablePromise<$OpenApiTs['/api/v1/invitations/{userId}']['patch']['res'][200]> {
    const { userId, invitationToken, requestBody } = data;
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/v1/invitations/{userId}',
      path: {
        userId,
      },
      query: {
        invitationToken,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
}

export class OrganizationsService {
  /**
   * @returns Organization
   * @throws ApiError
   */
  public static create(
    data: $OpenApiTs['/api/v1/organizations']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/v1/organizations']['post']['res'][201]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/organizations',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns Organization
   * @throws ApiError
   */
  public static findAll(
    data: $OpenApiTs['/api/v1/organizations']['get']['req'] = {},
  ): CancelablePromise<$OpenApiTs['/api/v1/organizations']['get']['res'][200]> {
    const { search, adminLevelId, networkId, employeeRange, includeLocations, status } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/organizations',
      query: {
        search,
        adminLevelId,
        networkId,
        employeeRange,
        includeLocations,
        status,
      },
    });
  }

  /**
   * @returns Organization
   * @throws ApiError
   */
  public static findOne(
    data: $OpenApiTs['/api/v1/organizations/{id}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/v1/organizations/{id}']['get']['res'][200]> {
    const { id, includeLocations, includeOrganizationUsers, includeIndicatorProcesses } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/organizations/{id}',
      path: {
        id,
      },
      query: {
        includeLocations,
        includeOrganizationUsers,
        includeIndicatorProcesses,
      },
    });
  }

  /**
   * @returns Organization
   * @throws ApiError
   */
  public static update(
    data: $OpenApiTs['/api/v1/organizations/{id}']['patch']['req'],
  ): CancelablePromise<$OpenApiTs['/api/v1/organizations/{id}']['patch']['res'][200]> {
    const { id, requestBody } = data;
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/v1/organizations/{id}',
      path: {
        id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns Organization
   * @throws ApiError
   */
  public static remove(
    data: $OpenApiTs['/api/v1/organizations/{id}']['delete']['req'],
  ): CancelablePromise<$OpenApiTs['/api/v1/organizations/{id}']['delete']['res'][200]> {
    const { id } = data;
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/v1/organizations/{id}',
      path: {
        id,
      },
    });
  }
}

export class LocationsService {
  /**
   * @returns Location
   * @throws ApiError
   */
  public static create(
    data: $OpenApiTs['/api/v1/locations']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/v1/locations']['post']['res'][201]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/locations',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns Location
   * @throws ApiError
   */
  public static findAll(
    data: $OpenApiTs['/api/v1/locations']['get']['req'] = {},
  ): CancelablePromise<$OpenApiTs['/api/v1/locations']['get']['res'][200]> {
    const { search, profileStatus } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/locations',
      query: {
        search,
        profileStatus,
      },
    });
  }

  /**
   * @returns Location
   * @throws ApiError
   */
  public static findOne(
    data: $OpenApiTs['/api/v1/locations/{id}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/v1/locations/{id}']['get']['res'][200]> {
    const { id } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/locations/{id}',
      path: {
        id,
      },
    });
  }

  /**
   * @returns Location
   * @throws ApiError
   */
  public static update(
    data: $OpenApiTs['/api/v1/locations/{id}']['patch']['req'],
  ): CancelablePromise<$OpenApiTs['/api/v1/locations/{id}']['patch']['res'][200]> {
    const { id, requestBody } = data;
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/v1/locations/{id}',
      path: {
        id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns Location
   * @throws ApiError
   */
  public static remove(
    data: $OpenApiTs['/api/v1/locations/{id}']['delete']['req'],
  ): CancelablePromise<$OpenApiTs['/api/v1/locations/{id}']['delete']['res'][200]> {
    const { id } = data;
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/v1/locations/{id}',
      path: {
        id,
      },
    });
  }
}

export class LocationProfilesService {
  /**
   * @returns LocationProfile
   * @throws ApiError
   */
  public static findOne(
    data: $OpenApiTs['/api/v1/location-profiles/{locationId}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/v1/location-profiles/{locationId}']['get']['res'][200]> {
    const { locationId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/location-profiles/{locationId}',
      path: {
        locationId,
      },
    });
  }

  /**
   * @returns unknown
   * @throws ApiError
   */
  public static update(
    data: $OpenApiTs['/api/v1/location-profiles/{locationId}']['patch']['req'],
  ): CancelablePromise<$OpenApiTs['/api/v1/location-profiles/{locationId}']['patch']['res'][200]> {
    const { locationId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/v1/location-profiles/{locationId}',
      path: {
        locationId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
}

export class EmployeesService {
  /**
   * @returns Employee
   * @throws ApiError
   */
  public static create(
    data: $OpenApiTs['/api/v1/employees']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/v1/employees']['post']['res'][201]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/employees',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns Employee
   * @throws ApiError
   */
  public static findAll(): CancelablePromise<$OpenApiTs['/api/v1/employees']['get']['res'][200]> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/employees',
    });
  }

  /**
   * @returns Employee
   * @throws ApiError
   */
  public static findOne(
    data: $OpenApiTs['/api/v1/employees/{id}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/v1/employees/{id}']['get']['res'][200]> {
    const { id } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/employees/{id}',
      path: {
        id,
      },
    });
  }

  /**
   * @returns Employee
   * @throws ApiError
   */
  public static update(
    data: $OpenApiTs['/api/v1/employees/{id}']['patch']['req'],
  ): CancelablePromise<$OpenApiTs['/api/v1/employees/{id}']['patch']['res'][200]> {
    const { id, requestBody } = data;
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/v1/employees/{id}',
      path: {
        id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns Employee
   * @throws ApiError
   */
  public static remove(
    data: $OpenApiTs['/api/v1/employees/{id}']['delete']['req'],
  ): CancelablePromise<$OpenApiTs['/api/v1/employees/{id}']['delete']['res'][200]> {
    const { id } = data;
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/v1/employees/{id}',
      path: {
        id,
      },
    });
  }
}

export class NetworksService {
  /**
   * @returns Network
   * @throws ApiError
   */
  public static create(
    data: $OpenApiTs['/api/v1/networks']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/v1/networks']['post']['res'][201]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/networks',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns Network
   * @throws ApiError
   */
  public static findAll(): CancelablePromise<$OpenApiTs['/api/v1/networks']['get']['res'][200]> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/networks',
    });
  }

  /**
   * @returns Network
   * @throws ApiError
   */
  public static findOne(
    data: $OpenApiTs['/api/v1/networks/{id}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/v1/networks/{id}']['get']['res'][200]> {
    const { id, includeLocations } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/networks/{id}',
      path: {
        id,
      },
      query: {
        includeLocations,
      },
    });
  }

  /**
   * @returns Network
   * @throws ApiError
   */
  public static update(
    data: $OpenApiTs['/api/v1/networks/{id}']['patch']['req'],
  ): CancelablePromise<$OpenApiTs['/api/v1/networks/{id}']['patch']['res'][200]> {
    const { id, requestBody } = data;
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/v1/networks/{id}',
      path: {
        id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns Network
   * @throws ApiError
   */
  public static remove(
    data: $OpenApiTs['/api/v1/networks/{id}']['delete']['req'],
  ): CancelablePromise<$OpenApiTs['/api/v1/networks/{id}']['delete']['res'][200]> {
    const { id } = data;
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/v1/networks/{id}',
      path: {
        id,
      },
    });
  }
}

export class AdminLevelsService {
  /**
   * @returns AdminLevel
   * @throws ApiError
   */
  public static create(
    data: $OpenApiTs['/api/v1/admin-levels']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/v1/admin-levels']['post']['res'][201]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/admin-levels',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns AdminLevel
   * @throws ApiError
   */
  public static findAll(
    data: $OpenApiTs['/api/v1/admin-levels']['get']['req'] = {},
  ): CancelablePromise<$OpenApiTs['/api/v1/admin-levels']['get']['res'][200]> {
    const { type, depth, publication } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/admin-levels',
      query: {
        type,
        depth,
        publication,
      },
    });
  }

  /**
   * @returns AdminLevel
   * @throws ApiError
   */
  public static findOne(
    data: $OpenApiTs['/api/v1/admin-levels/{id}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/v1/admin-levels/{id}']['get']['res'][200]> {
    const { id, includeLocations } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/admin-levels/{id}',
      path: {
        id,
      },
      query: {
        includeLocations,
      },
    });
  }

  /**
   * @returns AdminLevel
   * @throws ApiError
   */
  public static update(
    data: $OpenApiTs['/api/v1/admin-levels/{id}']['patch']['req'],
  ): CancelablePromise<$OpenApiTs['/api/v1/admin-levels/{id}']['patch']['res'][200]> {
    const { id, requestBody } = data;
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/v1/admin-levels/{id}',
      path: {
        id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns AdminLevel
   * @throws ApiError
   */
  public static remove(
    data: $OpenApiTs['/api/v1/admin-levels/{id}']['delete']['req'],
  ): CancelablePromise<$OpenApiTs['/api/v1/admin-levels/{id}']['delete']['res'][200]> {
    const { id } = data;
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/v1/admin-levels/{id}',
      path: {
        id,
      },
    });
  }
}

export class OrganizationUsersService {
  /**
   * @returns OrganizationUser
   * @throws ApiError
   */
  public static create(
    data: $OpenApiTs['/api/v1/organization-users']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/v1/organization-users']['post']['res'][201]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/organization-users',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns OrganizationUser
   * @throws ApiError
   */
  public static findAll(
    data: $OpenApiTs['/api/v1/organization-users']['get']['req'] = {},
  ): CancelablePromise<$OpenApiTs['/api/v1/organization-users']['get']['res'][200]> {
    const { organizationId, includeUsers, search } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/organization-users',
      query: {
        organizationId,
        includeUsers,
        search,
      },
    });
  }

  /**
   * @returns OrganizationUser
   * @throws ApiError
   */
  public static update(
    data: $OpenApiTs['/api/v1/organization-users/{organizationId}/{userId}']['patch']['req'],
  ): CancelablePromise<$OpenApiTs['/api/v1/organization-users/{organizationId}/{userId}']['patch']['res'][200]> {
    const { organizationId, userId, requestBody } = data;
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/v1/organization-users/{organizationId}/{userId}',
      path: {
        organizationId,
        userId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns OrganizationUser
   * @throws ApiError
   */
  public static remove(
    data: $OpenApiTs['/api/v1/organization-users/{organizationId}/{userId}']['delete']['req'],
  ): CancelablePromise<$OpenApiTs['/api/v1/organization-users/{organizationId}/{userId}']['delete']['res'][200]> {
    const { organizationId, userId } = data;
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/v1/organization-users/{organizationId}/{userId}',
      path: {
        organizationId,
        userId,
      },
    });
  }
}

export class InterestsService {
  /**
   * @returns CreateInterestDto
   * @throws ApiError
   */
  public static create(
    data: $OpenApiTs['/api/v1/interests']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/v1/interests']['post']['res'][201]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/interests',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
}

export class IndicatorProcessService {
  /**
   * @returns IndicatorProcess
   * @throws ApiError
   */
  public static create(
    data: $OpenApiTs['/api/v1/indicator-processes']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/v1/indicator-processes']['post']['res'][201]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/indicator-processes',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns IndicatorProcess
   * @throws ApiError
   */
  public static findAll(
    data: $OpenApiTs['/api/v1/indicator-processes']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/v1/indicator-processes']['get']['res'][200]> {
    const { independent, search } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/indicator-processes',
      query: {
        independent,
        search,
      },
    });
  }

  /**
   * @returns IndicatorProcess
   * @throws ApiError
   */
  public static findOne(
    data: $OpenApiTs['/api/v1/indicator-processes/{id}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/v1/indicator-processes/{id}']['get']['res'][200]> {
    const { id } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/indicator-processes/{id}',
      path: {
        id,
      },
    });
  }

  /**
   * @returns IndicatorProcess
   * @throws ApiError
   */
  public static update(
    data: $OpenApiTs['/api/v1/indicator-processes/{id}']['patch']['req'],
  ): CancelablePromise<$OpenApiTs['/api/v1/indicator-processes/{id}']['patch']['res'][200]> {
    const { id, requestBody } = data;
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/v1/indicator-processes/{id}',
      path: {
        id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns any
   * @throws ApiError
   */
  public static remove(
    data: $OpenApiTs['/api/v1/indicator-processes/{id}']['delete']['req'],
  ): CancelablePromise<$OpenApiTs['/api/v1/indicator-processes/{id}']['delete']['res'][200]> {
    const { id } = data;
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/v1/indicator-processes/{id}',
      path: {
        id,
      },
    });
  }

  /**
   * @returns any
   * @throws ApiError
   */
  public static export(
    data: $OpenApiTs['/api/v1/indicator-processes/{id}/export']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/v1/indicator-processes/{id}/export']['get']['res'][200]> {
    const { id, indicatorType } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/indicator-processes/{id}/export',
      path: {
        id,
      },
      query: {
        indicatorType,
      },
    });
  }
}

export class IndicatorRoutingQueueService {
  /**
   * @returns IndicatorRoutingQueueStatusDto
   * @throws ApiError
   */
  public static status(): CancelablePromise<$OpenApiTs['/api/v1/indicator-routing-queue']['get']['res'][200]> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/indicator-routing-queue',
    });
  }

  /**
   * @returns any
   * @throws ApiError
   */
  public static resumeQueue(): CancelablePromise<$OpenApiTs['/api/v1/indicator-routing-queue']['post']['res'][201]> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/indicator-routing-queue',
    });
  }

  /**
   * @returns any
   * @throws ApiError
   */
  public static pauseQueue(): CancelablePromise<$OpenApiTs['/api/v1/indicator-routing-queue']['delete']['res'][200]> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/v1/indicator-routing-queue',
    });
  }

  /**
   * @returns any
   * @throws ApiError
   */
  public static scheduleCronJobs(): CancelablePromise<
    $OpenApiTs['/api/v1/indicator-routing-queue/cron-jobs']['post']['res'][201]
  > {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/indicator-routing-queue/cron-jobs',
    });
  }

  /**
   * @returns any
   * @throws ApiError
   */
  public static deleteCronJobs(): CancelablePromise<
    $OpenApiTs['/api/v1/indicator-routing-queue/cron-jobs']['delete']['res'][200]
  > {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/v1/indicator-routing-queue/cron-jobs',
    });
  }

  /**
   * @returns IndicatorRoutingConfiguration
   * @throws ApiError
   */
  public static getConfiguration(): CancelablePromise<
    $OpenApiTs['/api/v1/indicator-routing-queue/configuration']['get']['res'][200]
  > {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/indicator-routing-queue/configuration',
    });
  }

  /**
   * @returns IndicatorRoutingConfiguration
   * @throws ApiError
   */
  public static updateConfiguration(
    data: $OpenApiTs['/api/v1/indicator-routing-queue/configuration']['patch']['req'],
  ): CancelablePromise<$OpenApiTs['/api/v1/indicator-routing-queue/configuration']['patch']['res'][200]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/v1/indicator-routing-queue/configuration',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
}

export class MonitoringService {
  /**
   * @returns MonitoringLocationDto
   * @throws ApiError
   */
  public static findOne(
    data: $OpenApiTs['/api/v1/monitoring/{monitoringId}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/v1/monitoring/{monitoringId}']['get']['res'][200]> {
    const { monitoringId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/monitoring/{monitoringId}',
      path: {
        monitoringId,
      },
    });
  }

  /**
   * @returns Monitoring
   * @throws ApiError
   */
  public static create(
    data: $OpenApiTs['/api/v1/monitoring']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/v1/monitoring']['post']['res'][201]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/monitoring',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns Monitoring
   * @throws ApiError
   */
  public static createMobile(
    data: $OpenApiTs['/api/v1/monitoring/qr']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/v1/monitoring/qr']['post']['res'][201]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/monitoring/qr',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        429: `ThrottlerException: Too Many Requests.`,
      },
    });
  }

  /**
   * @returns MonitoringLocationDto
   * @throws ApiError
   */
  public static daily(
    data: $OpenApiTs['/api/v1/monitoring/daily/{monitoringId}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/v1/monitoring/daily/{monitoringId}']['get']['res'][200]> {
    const { monitoringId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/monitoring/daily/{monitoringId}',
      path: {
        monitoringId,
      },
    });
  }

  /**
   * @returns MonitoringAnalysisData
   * @throws ApiError
   */
  public static analysis(
    data: $OpenApiTs['/api/v1/monitoring/analysis']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/v1/monitoring/analysis']['post']['res'][201]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/monitoring/analysis',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns MonitoringAnalysisData
   * @throws ApiError
   */
  public static sharedAnalysis(
    data: $OpenApiTs['/api/v1/monitoring/shared-analysis/{sharedAnalysisId}']['get']['req'],
  ): CancelablePromise<$OpenApiTs['/api/v1/monitoring/shared-analysis/{sharedAnalysisId}']['get']['res'][200]> {
    const { sharedAnalysisId } = data;
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/monitoring/shared-analysis/{sharedAnalysisId}',
      path: {
        sharedAnalysisId,
      },
      errors: {
        429: `ThrottlerException: Too Many Requests.`,
      },
    });
  }

  /**
   * @returns MonitoringAnalysisData
   * @throws ApiError
   */
  public static publicAnalysis(
    data: $OpenApiTs['/api/v1/monitoring/public-analysis']['post']['req'],
  ): CancelablePromise<$OpenApiTs['/api/v1/monitoring/public-analysis']['post']['res'][201]> {
    const { requestBody } = data;
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/monitoring/public-analysis',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns AdminLevel
   * @throws ApiError
   */
  public static publicAnalysisAdminLevels(): CancelablePromise<
    $OpenApiTs['/api/v1/monitoring/public-analysis/admin-levels']['get']['res'][200]
  > {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/monitoring/public-analysis/admin-levels',
    });
  }
}
